module.exports = __webpack_public_path__ + "ad7beca6eb533df7efe344426bb5cf00.pdf";